import { render } from "./Main.vue?vue&type=template&id=3120de9c&scoped=true"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-3120de9c"

export default script